export default __webpack_public_path__ + "static/media/lorry_disabled.15ea27b9.svg";